import { HttpErrorResponse } from '@angular/common/http';
import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import {
	BillBackfaceService,
	BillOperate,
	ElementRoute,
	IBillPostEventBody,
	IField,
	RouteElementService,
	ITableCheckResult,
	BillFieldDataType
} from 'dbweb-core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { TabsService } from '../home/tabs.service';
import { BillCloneBackfaceService } from './bill-clone-backface.service';
import { CloneComponent } from './clone/clone.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
interface Record {
	Main: { [key: string]: any };
	Child?: { [key: string]: { [key: string]: any }[] };
}
export interface BeforeSaveParam {
	record: { [key: string]: any } | Record;
	tag?: any;
}
@Component({
	selector: 'common-bill',
	templateUrl: './bill.component.html',
	styleUrls: ['./bill.component.scss']
})
export class BillComponent implements OnInit, AfterContentInit {
	@Input() onBeforeSave: (selft: BillComponent) => Observable<BeforeSaveParam>;
	@Output() init = new EventEmitter();
	public element: ElementRoute;
	private oldData: string;
	private operate: BillOperate;
	public allowClone: boolean;
	public checkResults: ITableCheckResult[];
	public fieldMap: { [key: string]: IField };
	public fields: IField[]; // è¿éçNameä¾æ®typestructæ¥
	private useTypeRecord = false;
	private signKeyValues: string;
	public formGroup?: FormGroup;
	public typeRecord: { [key: string]: any } = {};
	public record: Record;
	public error: string;
	constructor(
		public rele: RouteElementService,
		private billBackface: BillBackfaceService,
		private tabs: TabsService,
		public dialog: MatDialog,
		private billCloneService: BillCloneBackfaceService,
		private snackBar: MatSnackBar
	) {
		this.rele.currentElement.subscribe(v => {
			this.element = v;
			this.billBackface.get(v).subscribe(
				vv => {
					this.checkResults = vv.CheckResults;
					this.oldData = vv.EncodeData;
					this.operate = vv.Operate;
					this.allowClone = vv.AllowClone;
					this.fields = vv.Fields;
					this.typeRecord = vv.TypeRecord;
					this.record = vv.Record;
					this.signKeyValues = vv.SignKeyValues;
					this.useTypeRecord = vv.TypeRecord !== undefined && vv.TypeRecord !== null;
					// å¯¹ä¸»è¡¨å­æ®µçæ å°
					this.fieldMap = vv.Fields.reduce((result, item) => {
						result[item.Name] = item;
						return result;
					}, {});
					// åªå»ºç«ä¸»è¡¨çformgroup
					if (this.useTypeRecord) {
						this.formGroup = new FormGroup(
							this.fields.reduce((result, fld) => {
								if (fld.Type === BillFieldDataType.DATE && this.typeRecord[fld.Name]) {
									result[fld.Name] = new FormControl({
										value: this.fixShowDate(this.typeRecord[fld.Name] as string), // å»ææ¶åº
										disabled: fld.Readonly
									});
								} else {
									result[fld.Name] = new FormControl({
										value: this.typeRecord[fld.Name],
										disabled: fld.Readonly
									});
								}
								return result;
							}, {})
						);
					} else {
						this.formGroup = new FormGroup(
							this.fields.reduce((result, fld) => {
								if (fld.Type === BillFieldDataType.DATE && this.record.Main[fld.Name]) {
									result[fld.Name] = new FormControl({
										value: this.fixShowDate(this.record.Main[fld.Name] as string), // å»ææ¶åº
										disabled: fld.Readonly
									});
								} else {
									result[fld.Name] = new FormControl({
										value: this.record.Main[fld.Name],
										disabled: fld.Readonly
									});
								}
								return result;
							}, {})
						);
					}
					this.init.emit();
				},
				(err: HttpErrorResponse) => {
					this.error = err.error.Error;
				}
			);
		});
	}
	private fixShowDate(d: string): string {
		if (d) {
			return d.substr(0, 16);
		}
		return d;
	}
	ngAfterContentInit(): void {}
	showErrorMessage(mes: string): void {
		this.dialog.open(ErrorMessageComponent, {
			// width: '450px',
			data: { message: mes },
			autoFocus: false
		});

		// dialogRef.afterClosed().subscribe(result => {
		// 	console.log('The dialog was closed');
		// });
	}
	ngOnInit() {}
	isAdd() {
		return this.operate === BillOperate.Add;
	}
	isEdit() {
		return this.operate === BillOperate.Edit;
	}
	isDelete() {
		return this.operate === BillOperate.Delete;
	}
	isBrowse() {
		return this.operate === BillOperate.Browse;
	}
	close() {
		this.tabs.close();
	}
	private fixDate(d: Date) {
		const timezoneOffsetInHours = -(d.getTimezoneOffset() / 60); // UTC minus local time
		const sign = timezoneOffsetInHours >= 0 ? '+' : '-';
		const leadingZero = Math.abs(timezoneOffsetInHours) < 10 ? '0' : '';

		// It's a bit unfortunate that we need to construct a new Date instance
		// (we don't want _this_ Date instance to be modified)
		const correctedDate = new Date(
			d.getFullYear(),
			d.getMonth(),
			d.getDate(),
			d.getHours(),
			d.getMinutes(),
			d.getSeconds(),
			d.getMilliseconds()
		);
		correctedDate.setHours(d.getHours() + timezoneOffsetInHours);
		const iso = correctedDate.toISOString().replace('Z', '');

		return iso + sign + leadingZero + Math.abs(timezoneOffsetInHours).toString() + ':00';
	}
	// è¿åformgroupçè½¬æ¢å¥½ç±»åçå¼
	getFormGroupValueAsType(): { [key: string]: any } {
		const rev: { [key: string]: any } = {};
		this.fields.forEach(fld => {
			switch (fld.Type) {
				case BillFieldDataType.FLOAT:
					rev[fld.Name] = parseFloat(this.formGroup.get(fld.Name).value);
					break;
				case BillFieldDataType.INT:
					rev[fld.Name] = parseInt(this.formGroup.get(fld.Name).value, 10);
					break;
				case BillFieldDataType.DATE:
					if (this.formGroup.get(fld.Name).value) {
						rev[fld.Name] = this.fixDate(new Date(this.formGroup.get(fld.Name).value));
					} else {
						rev[fld.Name] = null;
					}
					break;
				default:
					rev[fld.Name] = this.formGroup.get(fld.Name).value;
					break;
			}
		});
		return rev;
	}
	save() {
		// åå¹¶ä¿®æ¹çæ°æ®
		if (this.useTypeRecord) {
			this.typeRecord = { ...this.typeRecord, ...this.getFormGroupValueAsType() };
		} else {
			this.record = {
				Main: { ...this.record.Main, ...this.getFormGroupValueAsType() },
				Child: { ...this.record.Child }
			};
		}
		const process = (data: BeforeSaveParam) => {
			// åå¹¶ä¿®æ¹çæ°æ®
			if (this.useTypeRecord) {
				this.typeRecord = { ...this.typeRecord, ...data ? data.record : null };
			} else {
				if (data && data.record) {
					this.record.Main = { ...this.record.Main, ...data.record.Main };
					this.record.Child = data.record.Child;
				}
			}
			this.billBackface
				.post(this.element, {
					CheckOnly: false,
					OldData: this.oldData,
					Tag: data ? data.tag : null,
					NewTypeRecord: this.typeRecord,
					NewRecord: this.record
				} as IBillPostEventBody)
				.subscribe(v => {
					if (v.Ok) {
						this.tabs.close();
						return;
					}
					this.showErrorMessage(v.Error);
				});
		};
		if (this.onBeforeSave) {
			this.onBeforeSave(this).subscribe(v => {
				process(v);
			});
		} else {
			process(null);
		}
	}
	delete() {
		return this.billBackface.delete(this.element, this.oldData).subscribe(v => {
			if (v.Ok) {
				this.tabs.close();
				return;
			}
			this.showErrorMessage(v.Error);
		});
	}
	clone() {
		this.billCloneService
			.getClonePK({ OldSignPK: this.signKeyValues, EleName: this.element.element.Name })
			.subscribe(v => {
				const dialogRef = this.dialog.open(CloneComponent, {
					// width: '450px',
					data: v
				});

				dialogRef.afterClosed().subscribe((result: { [key: string]: string }) => {
					if (result) {
						this.billCloneService
							.billClone({
								EleName: this.element.element.Name,
								OldSignPK: this.signKeyValues,
								NewPK: result
							})
							.subscribe(apirev => {
								if (apirev.Ok) {
									this.snackBar.open('æåå®æåé', 'å³é­', {
										horizontalPosition: 'right',
										verticalPosition: 'bottom',
										duration: 5000
									});
								} else {
									this.snackBar.open(apirev.Error, 'å³é­', {
										horizontalPosition: 'right',
										verticalPosition: 'bottom'
									});
								}
							});
					}
				});
			});
	}
}
